import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import InputText from "../../components/forms/elements/InputText";
import ContatoOrigemService from "../../services/ContatoOrigemService";
import CrudForm from "../../components/forms/custom/CrudForm";

class FormContatoOrigem extends CrudForm {

    constructor(props) {
        super(props);

        this.state.model = {
            idContatoOrigem: "",
            nome: ""
        };

        this.state.crud = {
            service: ContatoOrigemService,
            labels: {
                title: 'Combustível',
            },
            urlList: '/LstContatoOrigem',
        };
    }

    componentDidMount() {
        super.componentDidMount();
    }

    componentWillUnmount() {
        super.componentWillUnmount();
    }

    getRenderFields() {
        return (
            <div className="row mb-3 g-3">
                <InputText label="Código" md={3} value={this.state.model.idContatoOrigem} name="idContatoOrigem" readOnly opcionalLabel={false}/>
                <InputText label="Nome do Combustível" autoFocus={true} required md={9} value={this.state.model.nome} name="nome" onChange={this.handleChange} maxLength={100} />
            </div>
        );
    }

    render() {
        return super.render();
    }
}

function With(props) {
    let navigate = useNavigate();
    let params = useParams();
    return <FormContatoOrigem {...props} navigate={navigate} params={params} />
}

export default With